module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_akita-d0ad75862a17914ffcf471076fb394c2.png";